module.exports = __webpack_public_path__ + "img/fanganzixun.5daca08a.png";